import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <AppSection />
        <FaqSection />
        <IndexSection />
        <RankingSection />
        <MediaSection />
        <FeaturesSection />
        <ContactSection />
        <CarouselSection />
        <CardsSection />
        <AboutSection />
        <TopicsSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}